module.exports = __webpack_public_path__ + "img/img20.4a7c83c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/img20.jpg
// module id = 395
// module chunks = 0